// src/hooks/pricingUnits/useCreatePricingUnits.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createPricingUnit } from "../../api/apiPricingUnits";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

const useCreatePricingUnits = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: createPricingUnits,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: createPricingUnit,
        onSuccess: (response) => {
            toast.success(response.message);
            navigate('/pricing-units');
            queryClient.invalidateQueries({ queryKey: ["pricingUnits"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to create pricing unit");
        },
    });

    return {
        createPricingUnits,
        isPending: isPending || isLoading,
    };
};

export default useCreatePricingUnits;
